"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getGroupInfoRequest_1 = require("owa-service/lib/factory/getGroupInfoRequest");
var indexedPageView_1 = require("owa-service/lib/factory/indexedPageView");
var getGroupInfoOperation_1 = require("owa-service/lib/operation/getGroupInfoOperation");
function configureIndexedPageView() {
    return indexedPageView_1.default({
        BasePoint: 'Beginning',
        Offset: 0,
        MaxEntriesReturned: 100,
    });
}
function configureRequestBody(itemId, adObjectId, emailAddress) {
    return getGroupInfoRequest_1.default({
        ItemId: itemId,
        AdObjectId: adObjectId,
        EmailAddress: emailAddress,
        Paging: configureIndexedPageView(),
        ResultSet: 2 /* Members */,
    });
}
function getGroupInfo(itemId, adObjectId, emailAddress) {
    var requestBody = configureRequestBody(itemId, adObjectId, emailAddress);
    return getGroupInfoOperation_1.default({ getGroupInfoRequest: requestBody }).then(function (response) {
        var responseMessage = response;
        return responseMessage;
    });
}
exports.getGroupInfo = getGroupInfo;
//# sourceMappingURL=getGroupInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/services/getGroupInfo.js
// module id = 3183
// module chunks = 2 3